export enum EPromoCodeType {
    LARGE_PAY = 'largepay',
    BUNDLE = 'bundle',
    ADDON = 'addon',
    RTE = 'rte',
    DEMO_100 = 'demo100',
    MULTI_YEAR = 'multi1',
    GENERIC_2024 = 'promo2024',
}

export enum EProductType {
    ASSET = 'ASSET',
    MINDSPARK = 'MINDSPARK',
    CARES = 'CARES',
    CREST = 'CREST',
    MIRA = 'MIRA',
}

export enum ETestPack {
    THREE_TEST = '3-test pack',
    FOUR_TEST = '4-test pack',
}

export enum EDiscountType {
    SYSTEM = 'system',
    PROMO = 'promo',
}

export enum EOrderStatus {
    PROPOSAL_CREATED = 'proposal_created',
    PROPOSAL_REVIEW_PENDING = 'proposal_review_pending',
    PROPOSAL_SENT_TO_SCHOOL = 'proposal_sent_to_school',
}

export enum EDiscountValueType {
    PERCENTAGE = 'percentage',
    FIXED = 'fixed',
}

export enum EServiceStatus {
    SUCCESS = 'success',
    ERROR = 'error',
}
